import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TermsService } from 'modules/cms/terms/services';
import { TERMS_LIST_KEY } from 'modules/cms/terms/constants';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useDeleteTerms = (id: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('terms');
  return useMutation(() => TermsService.delete(id), {
    onSuccess: (data) => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries([TERMS_LIST_KEY]);
      queryClient.invalidateQueries([id]);
    },
  });
};
